import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './router/permission'
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入阿里图标
import '../font/iconfont.css'

// 格式化（css默认）
import './css/index.css'

Vue.use(ElementUI);

// 数据可视化DataV全部引入
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
